import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import { useNavigate } from "react-router-dom";
import autoTable from "jspdf-autotable";
import { useLoader } from "../../context/LoaderProvider";
const Foodbasicpaln = () => {
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [activeTab, setActiveTab] = useState("home");
    const [loading, setLoading] = useState(false);
    const [successPopup, setSuccessPopup] = useState(false); // ✅ Popup state
    const [accepted, setAccepted] = useState(false); // checkbox state
    const [showTerms, setShowTerms] = useState(false); // terms box show/hide
    const [countdown, setCountdown] = useState(10);
    const [selectedSubscriptionPlanId, setSelectedSubscriptionPlanId] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    const detailRef = useRef(null);
    const [plans, setPlans] = useState([]);
    const businessFeaturesList = [
        "Price",
        "Home",
        "Company",
        "Settings_Controls",
        "Account_History",
        "Order_Management",
        "Menu_Management",
        // "Payment_Transactions",
        "Report_Analysis",
        "Promotions_Discounts",
    ];

    const PLAN_ORDER = ["BASIC", "PREMIUM",];
    const navigate = useNavigate();


    useEffect(() => {
        showLoader();
        fetch("https://backend.maamaas.com/subscription/api/get/vertical/FOOD_AND_BEVERAGES")
            .then(res => res.json())
            .then(data => {
                // Filter only BASIC and PREMIUM plans
                const filtered = data.filter(plan => plan.planType === "BASIC");

                // Sort plans by planType and days
                filtered.sort((a, b) => {
                    if (a.planType === b.planType) return a.days - b.days; // sort by days within same type
                    return a.planType.localeCompare(b.planType); // sort by planType
                });

                setPlans(filtered);
            })
            .catch(error => console.error("Failed to load plans:", error)).finally(() => {
                hideLoader();
            })
    }, []);




    const pricingData = [
        {
            plan: "Basic",
            price: "₹0",
            features: {
                Subscription: true,
                Orders: true,
                Menu: true,
                Inventory: false,
                Payments: false,
                Promotions: false,
                Reports: false,
            },

        },

        {
            plan: "Premium",
            price: "₹50,000",
            features: {
                Subscription: true,
                Orders: true,
                Menu: true,
                Inventory: true,
                Payments: true,
                Promotions: true,
                Reports: true,
            },
        }
    ];

    const featureKeys = Object.keys(pricingData[0].features);



    useEffect(() => {
        if (expandedIndex !== null) {
            const interval = setInterval(() => {
                setCurrentSlide((prev) => (prev + 1) % pricingData[expandedIndex].slides.length);
            }, 4000);
            return () => clearInterval(interval);
        }
    }, [expandedIndex]);


    const initiatePayment = async (plan) => {
        // ✅ 1. Check Terms & Conditions acceptance
        if (!accepted) {
            alert("⚠️ Please accept Terms & Conditions before proceeding.");
            return;
        }

        // ✅ 2. Load Razorpay SDK
        const scriptLoaded = await loadRazorpayScript();
        if (!scriptLoaded) {
            alert("❌ Failed to load Razorpay SDK. Please try again later.");
            return;
        }

        // ✅ 3. Vendor & Plan details
        const vendorId = localStorage.getItem("vendorId") || 91;
        const subscriptionPlanId = selectedPlan?.id;

        if (!selectedPlan || selectedPlan.price == null) {
            alert("❌ Selected subscription plan is invalid or missing price.");
            return;
        }

        const amount = parseFloat(selectedPlan.price);
        const amountInPaise = Math.round(amount);
        // ✅ Razorpay needs paise

        try {
            // ✅ 4. Create Razorpay order (use correct backend endpoint)
            const orderRes = await axios.post(
                "https://backend.maamaas.com/subscription/api/user/create-order",
                {
                    amount: amountInPaise,
                    currency: "INR",
                    receipt: "receipt#1",
                    notes: {
                        key1: "value3",
                        key2: "value2",
                    },
                    vendorId: vendorId,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            //console.log("✅ Razorpay order response:", orderRes.data);

            const orderId = orderRes.data?.orderId || orderRes.data?.id || orderRes.data?.data?.orderId;
            if (!orderId) throw new Error("Order ID not received from backend");

            //console.log("✅ Razorpay Order Created. Order ID:", orderId);

            // ✅ 5. Razorpay Checkout Options
            const options = {
                // key: "rzp_live_RU5whSMu9rPV7s", // test key
                key: "rzp_live_RU5whSMu9rPV7s", // test key
                amount: amountInPaise,
                currency: "INR",
                name: "Mama's Website",
                description: "Subscription Payment",
                order_id: orderId,
                handler: async function (response) {
                    //console.log("✅ Razorpay Payment Success:", response);

                    generatePDF();
                    setActiveTab("Registration");
                    setSuccessPopup(true);

                    const paymentId = response.razorpay_payment_id;

                    // ✅ 6. Save Payment Data
                    const finalPaymentData = {
                        id: 0,
                        amount: amount,
                        subscriptionPlanId: subscriptionPlanId,
                        vendorId: vendorId,
                        razorpayPaymentId: paymentId,
                        razorpayOrderId: response.razorpay_order_id,
                        razorpaySignature: response.razorpay_signature,
                        operationType: "FOCO",
                        termsAndConditions: true,
                    };

                    //console.log("Saving payment data:", finalPaymentData);

                    try {
                        await axios.post(
                            "https://backend.maamaas.com/subscription/api/vendor/payment/create",
                            finalPaymentData,
                            {
                                headers: { "Content-Type": "application/json" },
                            }
                        );
                        //console.log("✅ Payment data saved.");
                    } catch (err) {
                        console.error("❌ Failed to save payment data:", err.response?.data || err.message);
                        alert("⚠️ Payment succeeded but saving data failed.");
                    }

                    // ✅ 7. Capture Payment
                    try {
                        await axios.post(
                            "https://backend.maamaas.com/subscription/api/user/capture",
                            {
                                paymentId: paymentId,
                                amount: amountInPaise,
                                currency: "INR",
                                vendorId: vendorId,
                            },
                            {
                                headers: { "Content-Type": "application/json" },
                            }
                        );
                        //console.log("✅ Payment captured successfully.");
                    } catch (captureError) {
                        console.error("❌ Payment capture failed:", captureError.response?.data || captureError.message);
                        alert("⚠️ Payment saved but capture failed.");
                    }
                },
                prefill: {
                    name: "Customer Name",
                    email: "customer@example.com",
                    contact: "9999999999",
                },
                theme: {
                    color: "#3399cc",
                },
            };

            // ✅ 8. Open Razorpay checkout
            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (err) {
            console.error("❌ Razorpay order creation failed:", err.response?.data || err.message);
            alert(`❌ Failed to create Razorpay order: ${err.response?.data?.message || err.message}`);
        }
    };





    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            if (window.Razorpay) {
                resolve(true);
            } else {
                const script = document.createElement("script");
                script.src = "https://checkout.razorpay.com/v1/checkout.js";
                script.onload = () => resolve(true);
                script.onerror = () => resolve(false);
                document.body.appendChild(script);
            }
        });
    };



    const generatePDF = () => {
        const doc = new jsPDF();

        // Header
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        doc.text("Maamaas House", 105, 15, { align: "center" });

        const currentDate = new Date();
        const dateStr = currentDate.toLocaleDateString();
        const timeStr = currentDate.toLocaleTimeString();

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");

        const vendorId = localStorage.getItem("vendorId") || 91;
        // const emailId = "vendor@example.com";

        doc.text(`Vendor ID: ${vendorId}`, 14, 32);
        // doc.text(`Email: ${emailId}`, 14, 39);

        doc.text(`Date: ${dateStr}`, 190, 32, { align: "right" });
        doc.text(`Time: ${timeStr}`, 190, 39, { align: "right" });

        const planName = selectedPlan?.planType || "Premium";
        const planPriceStr = String(selectedPlan?.price || "50000");
        const numericAmount = parseFloat(planPriceStr.replace(/[^0-9.-]+/g, ""));

        autoTable(doc, {
            startY: 50,
            head: [["Description", "Plan", "Amount"]],
            body: [
                ["Subscription Plan", planName, `₹${numericAmount.toLocaleString("en-IN")}.00`],
            ],
            theme: "grid",
            headStyles: { fillColor: [200, 200, 200], halign: "center" },
            columnStyles: {
                0: { halign: "center" }, // Description
                1: { halign: "center" }, // Plan
                2: { halign: "center" }, // Amount
            },
        });

        // Trigger PDF download
        doc.save(`Invoice_${vendorId}.pdf`);
    };








    useEffect(() => {
        if (successPopup) {
            setCountdown(5);

            const interval = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);

            const timer = setTimeout(() => {
                setSuccessPopup(false);
                clearInterval(interval);

                // ✅ Navigate after popup closes
                navigate("/");  // <-- change path as needed
            }, 5000); // ⏱ match countdown (5 sec)

            return () => {
                clearInterval(interval);
                clearTimeout(timer);
            };
        }
    }, [successPopup, navigate]);

    return (
        <>
            <style>{`
        /* ✅ Popup Overlay */
        .popup-overlay {
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 10px;
        }

        /* ✅ Popup Box */
        .popup-box {
          background: #fff;
          padding: 25px;
          border-radius: 12px;
          text-align: center;
          width: 100%;
          max-width: 400px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          animation: popupAnim 0.3s ease-in-out;
        }

        .popup-box h2 {
          color: #4CAF50;
          font-size: 22px;
          margin-bottom: 15px;
        }

        .popup-box p {
          font-size: 15px;
          margin-bottom: 20px;
          color: #333;
          line-height: 1.5;
        }

        .popup-box button {
          background: #4CAF50;
          color: #fff;
          border: none;
          padding: 12px 20px;
          border-radius: 6px;
          font-size: 15px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
        }

        @keyframes popupAnim {
          from { transform: scale(0.8); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }

        /* ✅ Responsive */
        @media (max-width: 768px) {
          .popup-box {
            max-width: 90%;
            padding: 20px;
          }
          .popup-box h2 {
            font-size: 20px;
          }
          .popup-box p {
            font-size: 14px;
          }
          .popup-box button {
            font-size: 14px;
          }
        }
  @media (min-width:968px) {
        .promo-section{
        padding: 20px !important;
        }
      }
      `}</style>


            {successPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h2>🎉 Payment Successful!</h2>
                        <p>
                            Your payment is successful. <br />
                            Your credentials have been sent to your registered Email ID. <br />
                            Please login with your credentials.
                        </p>
                        <p style={{ fontSize: "25px", marginTop: "10px", color: "#c83ecfff", fontWeight: 'bold' }}>
                            {countdown} seconds.
                        </p>
                    </div>
                </div>
            )}

            <div className="promo-section" >
                <h2 className="section-title" style={{ textAlign: "center" }}>
                    Subscription Plans Basic
                </h2>



                <table
                    className="feature-table"
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "20px",
                    }}
                >
                    <thead>
                        <tr>
                            <th style={styles.th}>Feature</th>
                            {plans.map((plan, index) => (
                                <th key={plan.id || index} style={styles.th}>
                                    {plan.days} Days
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {businessFeaturesList.map((feature, i) => (
                            <tr key={i}>
                                <td style={{ border: "1px solid #ccc", padding: "8px" }}>{feature.replace(/_/g, " ")}</td>
                                {plans.map((plan, j) => (
                                    <td key={j} style={{ border: "1px solid #ccc", padding: "8px" }}>
                                        {feature === "Price" ? (
                                            <strong>₹{plan.price || 0}/-</strong>
                                        ) : plan.businessModules?.includes(feature) ? (
                                            "✔️"
                                        ) : (
                                            "❌"
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}

                        {/* ✅ Pay Now Row */}
                        <tr>
                            <td style={{ border: "1px solid #ccc", padding: "8px" }}></td>
                            {plans.map((plan, i) => (
                                <td key={i} style={styles.td}>
                                    <button
                                        onClick={() => {
                                            //console.log("🟣 Selected Plan ID:", plan);
                                            setSelectedPlan(plan); // save selected plan (with days & price)
                                            setShowTerms(true);
                                        }}
                                        style={{
                                            padding: "6px 12px",
                                            backgroundColor: "#4CAF50",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "4px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Pay Now
                                    </button>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>




                {showTerms && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.5)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1000,
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "white",
                                padding: "20px",
                                borderRadius: "8px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                width: "350px",
                                textAlign: "center",
                            }}
                        >
                            <p style={{ fontSize: "14px", marginBottom: "15px", color: "#333" }}>
                                I hereby agree to the{" "}
                                <a
                                    href="/termsandcondions"
                                    // target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#007bff", textDecoration: "underline" }}
                                >
                                    Terms & Conditions
                                </a>{" "}
                                and{" "}
                                <a
                                    href="/termsandcondions"
                                    // target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#007bff", textDecoration: "underline" }}
                                >
                                    Privacy Policy
                                </a>{" "}
                                of Maamaas
                            </p>
                            <label
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    marginBottom: "12px",
                                    fontSize: "14px",
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={accepted}
                                    onChange={(e) => setAccepted(e.target.checked)}
                                />
                                I accept Terms & Conditions
                            </label>

                            <button
                                onClick={() => initiatePayment(selectedPlan)} // ✅ send full plan object
                                disabled={!accepted}
                                style={{
                                    padding: "6px 12px",
                                    backgroundColor: accepted ? "#4CAF50" : "#ccc",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    fontWeight: "bold",
                                    cursor: accepted ? "pointer" : "not-allowed",
                                    marginRight: "10px",
                                }}
                            >
                                Confirm & Pay
                            </button>


                            <button
                                onClick={() => {
                                    setShowTerms(false);
                                    setAccepted(false);
                                }}
                                style={{
                                    padding: "6px 12px",
                                    backgroundColor: "#f44336",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}


            </div>
        </>
    );
};

const styles = {
    th: {
        border: "1px solid #ccc",
        textAlign: "center",
        fontWeight: "bold",
        backgroundColor: "#b15cd6",
        color: "white",
        padding: "10px",
    },
    td: {
        border: "1px solid #ddd",
        textAlign: "center",
        padding: "10px",
    },
};

export default Foodbasicpaln;
